import { useEffect, useState } from "react";
import { Tabs } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import { pageTab } from "./navigation";
import type { Agent } from "./domain";
import { canAccessBusinessPath } from "./business";

const home = { key: "/", label: "首页", href: "/" };

export function PageTabs({ agent }: { agent: Agent }) {
  const location = useLocation();
  const navigate = useNavigate();
  const current = !canAccessBusinessPath(agent, location.pathname) || /^\/(?:tasks|reports|submissions|materials)(?:\/|$)/.test(location.pathname) ? null : pageTab(location.pathname, location.search, location.hash);
  const [opened, setOpened] = useState([home]);

  useEffect(() => {
    setOpened((existingTabs) => {
      const tabs = existingTabs.filter((tab) => canAccessBusinessPath(agent, tab.href.split(/[?#]/)[0]));
      if (!current) return tabs;
      const existing = tabs.find((tab) => tab.key === current.key);
      if (existing?.href === current.href) return tabs;
      return existing
        ? tabs.map((tab) => tab.key === current.key ? current : tab)
        : [...tabs, current];
    });
  }, [current?.key, current?.href, agent.allowed_task_types?.join(","), agent.advertising_enabled]);

  const close = (key: string) => {
    if (key === home.key) return;
    const index = opened.findIndex((tab) => tab.key === key);
    if (index < 0) return;
    if (key === current?.key) navigate(opened[index - 1]?.href || home.href);
    setOpened((tabs) => tabs.filter((tab) => tab.key !== key));
  };

  return (
    <nav className="agent-page-tabs" aria-label="已打开的页面">
      <Tabs
        type="editable-card"
        size="small"
        hideAdd
        activeKey={current?.key}
        items={opened.map((tab) => ({
          key: tab.key,
          label: tab.label,
          closable: tab.key !== home.key,
          closeIcon: <span aria-label={`关闭${tab.label}`}>×</span>,
        }))}
        onChange={(key) => {
          const tab = opened.find((item) => item.key === key);
          if (tab) navigate(tab.href);
        }}
        onEdit={(key, action) => {
          if (action === "remove" && typeof key === "string") close(key);
        }}
      />
    </nav>
  );
}
